
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// classes
import { DataState } from '@/core/classes/DataState.class'

// types
import { CityT } from '@/core/types/cities.types'

//realisations
import { cities } from '@/core/realisations/cities.realisation'

// constants
import { SHIPMENT_TYPES } from '@/core/constants/sla.constants'
import { CompanyT } from '@/core/types/companies.types'
import { companies } from '@/core/realisations/companies.realisation'

const PERIOD_OPTIONS = [
    { id: 1, name: 'Летний' },
    { id: 2, name: 'Зимний' },
]

export default defineComponent({
    components: {
        'the-button': TheButton,
        TheSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isFtl: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reset', 'search'],
    setup(props, { emit }) {
        const state = reactive({
            cityFromId: null as number | null,
            cityToId: null as number | null,
            shipmentTypeId: null as number | null,
            periodId: null as number | null,
            companyId: null as number | null,
            transit_cities: [] as Array<number | null>,
        })

        const data_state = reactive({
            from_cities: new DataState<CityT>({}),
            where_cities: new DataState<CityT>({}),
            transit_cities: new DataState<CityT>({}),
            companies: new DataState<CompanyT>({}),
        })

        const reset = () => {
            if (props.loading) return

            state.cityFromId = null
            state.cityToId = null
            state.shipmentTypeId = null
            state.periodId = null
            state.companyId = null
            state.transit_cities = []

            emit('reset')
        }

        const search = () => {
            if (props.loading) return

            emit('search', {
                fromCityId: state.cityFromId,
                toCityId: state.cityToId,
                shipmentTypeId: state.shipmentTypeId,
                periodId: state.periodId,
                companyId: state.companyId,
                transitCities: state.transit_cities,
            })
        }

        //

        const loadFromCities = async (page: number, search?: string) => {
            data_state.from_cities.pagination.current_page = page

            try {
                data_state.from_cities.is_loading = true

                const data = await cities.getAllList(page, search)
                data_state.from_cities.list = data.data

                data_state.from_cities.pagination.total_pages = data.meta.last_page

                data_state.from_cities.is_failed = false
                data_state.from_cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.from_cities.failure.catchError(error)

                if (!data_state.from_cities.failure.error_state.is_cancel) {
                    data_state.from_cities.is_failed = true
                }
            } finally {
                if (!data_state.from_cities.failure.error_state.is_cancel) {
                    data_state.from_cities.is_loading = false
                }
            }
        }

        const loadMoreFromCities = async (page: number) => {
            if (page > data_state.from_cities.pagination.total_pages) return
            data_state.from_cities.pagination.current_page = page

            try {
                data_state.from_cities.is_loading = true

                const response = await cities.getAllList(page)
                data_state.from_cities.list = data_state.from_cities.list.concat(response.data)

                data_state.from_cities.pagination.total_pages = response.meta.last_page

                data_state.from_cities.is_failed = false
                data_state.from_cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.from_cities.failure.catchError(error)

                if (!data_state.from_cities.failure.error_state.is_cancel) {
                    data_state.from_cities.is_failed = true
                }
            } finally {
                if (!data_state.from_cities.failure.error_state.is_cancel) {
                    data_state.from_cities.is_loading = false
                }
            }
        }

        const searchFromCity = (search_query: string) => {
            // data_state.from_cities.pagination.current_page
            loadFromCities(1, search_query)
        }

        const unshiftFindedFromCity = async (city: CityT) => {
            await loadFromCities(data_state.from_cities.pagination.current_page)
            data_state.from_cities.list.unshift(city)
        }

        //

        const loadWhereCities = async (page: number, search?: string) => {
            data_state.where_cities.pagination.current_page = page

            try {
                data_state.where_cities.is_loading = true

                const data = await cities.getAllList(page, search)
                data_state.where_cities.list = data.data

                data_state.where_cities.pagination.total_pages = data.meta.last_page

                data_state.where_cities.is_failed = false
                data_state.where_cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.where_cities.failure.catchError(error)

                if (!data_state.where_cities.failure.error_state.is_cancel) {
                    data_state.where_cities.is_failed = true
                }
            } finally {
                if (!data_state.where_cities.failure.error_state.is_cancel) {
                    data_state.where_cities.is_loading = false
                }
            }
        }

        const loadMoreWhereCities = async (page: number) => {
            if (page > data_state.where_cities.pagination.total_pages) return
            data_state.where_cities.pagination.current_page = page

            try {
                data_state.where_cities.is_loading = true

                const response = await cities.getAllList(page)
                data_state.where_cities.list = data_state.where_cities.list.concat(response.data)

                data_state.where_cities.pagination.total_pages = response.meta.last_page

                data_state.where_cities.is_failed = false
                data_state.where_cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.where_cities.failure.catchError(error)

                if (!data_state.where_cities.failure.error_state.is_cancel) {
                    data_state.where_cities.is_failed = true
                }
            } finally {
                if (!data_state.where_cities.failure.error_state.is_cancel) {
                    data_state.where_cities.is_loading = false
                }
            }
        }

        const searchWhereCity = (search_query: string) => {
            // data_state.where_cities.pagination.current_page
            loadWhereCities(1, search_query)
        }

        const unshiftFindedWhereCity = async (city: CityT) => {
            await loadWhereCities(data_state.where_cities.pagination.current_page)
            data_state.where_cities.list.unshift(city)
        }

        //

        const loadTransitCities = async (page: number, search?: string) => {
            data_state.transit_cities.pagination.current_page = page

            try {
                data_state.transit_cities.is_loading = true

                const data = await cities.getAllList(page, search)
                data_state.transit_cities.list = data.data

                data_state.transit_cities.pagination.total_pages = data.meta.last_page

                data_state.transit_cities.is_failed = false
                data_state.transit_cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.transit_cities.failure.catchError(error)

                if (!data_state.transit_cities.failure.error_state.is_cancel) {
                    data_state.transit_cities.is_failed = true
                }
            } finally {
                if (!data_state.transit_cities.failure.error_state.is_cancel) {
                    data_state.transit_cities.is_loading = false
                }
            }
        }

        const loadMoreTransitCities = async (page: number) => {
            if (page > data_state.transit_cities.pagination.total_pages) return
            data_state.transit_cities.pagination.current_page = page

            try {
                data_state.transit_cities.is_loading = true

                const response = await cities.getAllList(page)
                data_state.transit_cities.list = data_state.transit_cities.list.concat(
                    response.data
                )

                data_state.transit_cities.pagination.total_pages = response.meta.last_page

                data_state.transit_cities.is_failed = false
                data_state.transit_cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.transit_cities.failure.catchError(error)

                if (!data_state.transit_cities.failure.error_state.is_cancel) {
                    data_state.transit_cities.is_failed = true
                }
            } finally {
                if (!data_state.transit_cities.failure.error_state.is_cancel) {
                    data_state.transit_cities.is_loading = false
                }
            }
        }

        const searchTransitCity = (search_query: string) => {
            // data_state.to_cities.pagination.current_page
            loadTransitCities(1, search_query)
        }

        const unshiftFindedTransitCity = async (city: CityT) => {
            await loadTransitCities(data_state.transit_cities.pagination.current_page)
            data_state.transit_cities.list.unshift(city)
        }

        //

        const loadCities = async () => {
            try {
                data_state.from_cities.is_loading = true
                data_state.where_cities.is_loading = true
                data_state.transit_cities.is_loading = true

                const data = await cities.getAllList(1)

                data_state.from_cities.list = data.data
                data_state.where_cities.list = data.data
                data_state.transit_cities.list = data.data

                data_state.from_cities.pagination.total_pages = data.meta.last_page
                data_state.where_cities.pagination.total_pages = data.meta.last_page
                data_state.transit_cities.pagination.total_pages = data.meta.last_page

                data_state.from_cities.is_failed = false
                data_state.where_cities.is_failed = false
                data_state.transit_cities.is_failed = false

                data_state.from_cities.failure.error_state.is_cancel = false
                data_state.where_cities.failure.error_state.is_cancel = false
                data_state.transit_cities.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.from_cities.failure.catchError(error)
                data_state.where_cities.failure.catchError(error)
                data_state.transit_cities.failure.catchError(error)

                if (
                    !data_state.from_cities.failure.error_state.is_cancel &&
                    !data_state.where_cities.failure.error_state.is_cancel &&
                    !data_state.transit_cities.failure.error_state.is_cancel
                ) {
                    data_state.from_cities.is_failed = true
                    data_state.where_cities.is_failed = true
                    data_state.transit_cities.is_failed = true
                }
            } finally {
                if (
                    !data_state.from_cities.failure.error_state.is_cancel &&
                    !data_state.where_cities.failure.error_state.is_cancel &&
                    !data_state.transit_cities.failure.error_state.is_cancel
                ) {
                    data_state.from_cities.is_loading = false
                    data_state.where_cities.is_loading = false
                    data_state.transit_cities.is_loading = false
                }
            }
        }

        const addTransitCity = () => {
            state.transit_cities.push(null)
        }

        const deleteTransitCity = (transit_city_index: number) => {
            const answer = confirm(
                `Вы действительно хотите удалить транзитный город №${transit_city_index + 1}?`
            )
            if (!answer) return

            state.transit_cities.splice(transit_city_index, 1)
        }

        const loadCompanies = async (page: number, search?: string) => {
            data_state.companies.pagination.current_page = page

            try {
                data_state.companies.is_loading = true
                const response = await companies.getList({
                    page,
                    search,
                    statusId: 2,
                    isExtended: 0,
                })
                data_state.companies.list = response.data

                data_state.companies.pagination.total_pages = response.meta.last_page

                data_state.companies.is_failed = false
                data_state.companies.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.companies.failure.catchError(error)

                if (!data_state.companies.failure.error_state.is_cancel) {
                    data_state.companies.is_failed = true
                }
            } finally {
                if (!data_state.companies.failure.error_state.is_cancel) {
                    data_state.companies.is_loading = false
                }
            }
        }

        const loadMoreCompanies = async (page: number) => {
            if (page > data_state.companies.pagination.total_pages) return
            data_state.companies.pagination.current_page = page

            try {
                data_state.companies.is_loading = true

                const response = await companies.getList({ page, statusId: 2, isExtended: 0 })
                data_state.companies.list = data_state.companies.list.concat(response.data)

                data_state.companies.pagination.total_pages = response.meta.last_page

                data_state.companies.is_failed = false
                data_state.companies.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.companies.failure.catchError(error)

                if (!data_state.companies.failure.error_state.is_cancel) {
                    data_state.companies.is_failed = true
                }
            } finally {
                if (!data_state.companies.failure.error_state.is_cancel) {
                    data_state.companies.is_loading = false
                }
            }
        }

        //

        onBeforeMount(() => {
            loadCompanies(1)
            loadCities()
        })

        return {
            state,
            data_state,
            //
            reset,
            search,
            //
            loadFromCities,
            loadMoreFromCities,
            searchFromCity,
            unshiftFindedFromCity,
            //
            loadWhereCities,
            loadMoreWhereCities,
            searchWhereCity,
            unshiftFindedWhereCity,
            //
            loadTransitCities,
            loadMoreTransitCities,
            searchTransitCity,
            unshiftFindedTransitCity,
            //
            loadCompanies,
            loadMoreCompanies,
            //
            addTransitCity,
            deleteTransitCity,
            //
            loadCities,
            //
            SHIPMENT_TYPES,
            PERIOD_OPTIONS,
        }
    },
})
